/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { TEAM_URLS } from '@/api/url';
import { AccountRole } from '@/types/enums';
import { isAxiosError } from 'axios';

export interface GetTeamResponse {
  team_members: Account[];
  invitations: AccountInvitation[];
  max_members: number;
  current_members: number;
}

export const apiGetTeam = async (): Promise<ApiResponse<GetTeamResponse>> => {
  try {
    const response = await api.get<ApiResponse<GetTeamResponse>>(TEAM_URLS.GET_ALL);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface InviteTeamPayload {
  email: string;
  role: AccountRole;
}

export const apiInviteTeam = async (payload: InviteTeamPayload): Promise<ApiResponse<void>> => {
  try {
    const response = await api.post<ApiResponse<void>>(TEAM_URLS.INVITE, payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface RemoveInvitationPayload {
  email: string;
}

export const apiRemoveInvitation = async (
  payload: RemoveInvitationPayload
): Promise<ApiResponse<void>> => {
  try {
    const response = await api.delete<ApiResponse<void>>(TEAM_URLS.REMOVE_INVITATION, {
      data: payload
    });
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface UpdateMemberRolePayload {
  account_id: string;
  role: AccountRole;
}

export const apiUpdateMemberRole = async (
  payload: UpdateMemberRolePayload
): Promise<ApiResponse<void>> => {
  try {
    const response = await api.put<ApiResponse<void>>(TEAM_URLS.UPDATE_ROLE, payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface RemoveMemberPayload {
  account_id: string;
}

export const apiRemoveMember = async (payload: RemoveMemberPayload): Promise<ApiResponse<void>> => {
  try {
    const response = await api.delete<ApiResponse<void>>(TEAM_URLS.REMOVE_MEMBER, {
      data: payload
    });
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
